import { Saica } from "./../types/saica.type";
import { responseHandlerDefault } from "./../utils/handler.util";
import { Filter } from "./../types/filter.type";
import axios from "./api";
import { Pagination } from "./../types/pagination.type";

export const postSaica = (saica: Saica): Promise<Saica> => {
  return axios.post<Saica>("/saica/", saica).then(responseHandlerDefault);
};

export const getSaicas = (
  page?: number,
  size?: number,
  filter?: Filter,
  select?: string[]
): Promise<Pagination<Saica>> => {
  const params: { page?: number; size?: number; filter?: Filter; select?: string[] } = {};
  if (page) {
    params.page = page;
  }
  if (size) {
    params.size = size;
  }
  if (filter) {
    params.filter = filter;
  }
  if (select) {
    params.select = select;
  }
  return axios.get<Pagination<Saica>>(`/saica/`, { params }).then(responseHandlerDefault);
};
